import type { PropType } from 'virtual-vue';
import type { CheckboxOption } from './checkbox';

/**
 * checkbox-group组件的props
 * 基于方案设计文档生成
 */
export const checkboxGroupProps = {
  /**
   * 是否禁用全部子多选框
   */
  disabled: Boolean,

  /**
   * 多选组件按钮形式
   */
  options: {
    type: Array as PropType<Array<CheckboxOption>>,
  },

  /**
   * 选中的值（Vue2）。支持语法糖 v-model
   */
  value: {
    type: Array as PropType<Array<string | number | boolean>>,
    default: () => [],
  },

  /**
   * 选中的值（Vue3）。支持语法糖 v-model
   */
  modelValue: {
    type: Array as PropType<Array<string | number | boolean>>,
    default: () => [],
  },
};

